import { Component, OnInit, SimpleChanges, Input, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { Observable } from 'rxjs';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import { UserRoleService } from '../../services/user-role.service';
import { DocumentService } from '../../services/document.service'
import * as _ from 'lodash';
import { subDays } from 'date-fns';
import { resolve } from 'url';
import { reject } from 'q';
import { CourseSignaturePadComponent } from '../course-signature-pad/course-signature-pad.component';
@Component({
  selector: 'app-marking-scheme-l3',
  templateUrl: './marking-scheme-l3.component.html',
  styleUrls: ['./marking-scheme-l3.component.scss']
})
export class MarkingSchemeL3Component implements OnInit {

  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  @Input('learnerId') currentLearner

  markingSchemaForm: any
  markingSchemaFormEdit
  learnerData
  loading = false
  remarkList = [];
  inputCurrentValue
  learnerName
  jobData
  assessorSign1: boolean
  learnerSign1: boolean
  IQASign1: boolean
  assessorSign2: boolean
  learnerSign2: boolean
  IQASign2: boolean
  assessorSign3: boolean
  learnerSign3: boolean
  IQASign3: boolean
  assessorSign4: boolean
  learnerSign4: boolean
  IQASign4: boolean
  assessorSign5: boolean
  learnerSign5: boolean
  IQASign5: boolean
  assessorSign6: boolean
  learnerSign6: boolean
  IQASign6: boolean
  isLearner: boolean = false
  isAdmin: boolean = false
  isTrainer: boolean = false
  user
  admin
  selectedLearner: any;
  currentUser: any;
  isIQA: boolean = false;
  parrentJobId
  isConnect: boolean = false

  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public cd: ChangeDetectorRef,
    public _userRoleService: UserRoleService,
    public _documentService: DocumentService
  ) {

    // this._documentService.markingSchemeObservable().subscribe((res) => {
    //   console.log("When download the marking scheme", res);

    //   this.markingSubmit(res)



    // })

  }

  ngOnInit() {
    this.formCreate()
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes of marking scheme", changes);

    if (changes.currentLearner && changes.currentLearner.currentValue) {
      this.selectedLearner = changes.currentLearner.currentValue
    }


    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue[0]
      this.getUserRole();
      // this.instructorsList = this.jobData.instructors
      console.log("instructorsList ====== instructorsList!!!!!!!!!!!!!!!!!!!!!!!!!!!!1", this.jobData._id);
      this.getRemark(this.jobData._id)
    }



    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.markingSchemaFormEdit = changes.assessmentEdit.currentValue
      console.log("edit form value", this.markingSchemaFormEdit);
      let size = Object.keys(this.markingSchemaFormEdit).length;
      console.log("what is the size of object", size);

      if (size != 0) {


        if (this.markingSchemaFormEdit && this.markingSchemaFormEdit.markingSchemaForm) {

          //  form 1
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.assessorSign1 && this.markingSchemaFormEdit.markingSchemaForm.assessorSign1 != "") {
            this.assessorSign1 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.learnerSign1 && this.markingSchemaFormEdit.markingSchemaForm.learnerSign1 != "") {
            this.learnerSign1 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.IQASign1 && this.markingSchemaFormEdit.markingSchemaForm.IQASign1 != "") {
            this.IQASign1 = true
          }

          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.assessorSign2 && this.markingSchemaFormEdit.markingSchemaForm.assessorSign2 != "") {
            this.assessorSign2 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.learnerSign2 && this.markingSchemaFormEdit.markingSchemaForm.learnerSign2 != "") {
            this.learnerSign2 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.IQASign2 && this.markingSchemaFormEdit.markingSchemaForm.IQASign2 != "") {
            this.IQASign2 = true
          }

          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.assessorSign3 && this.markingSchemaFormEdit.markingSchemaForm.assessorSign3 != "") {
            this.assessorSign3 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.learnerSign3 && this.markingSchemaFormEdit.markingSchemaForm.learnerSign3 != "") {
            this.learnerSign3 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.IQASign3 && this.markingSchemaFormEdit.markingSchemaForm.IQASign3 != "") {
            this.IQASign3 = true
          }

          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.assessorSign4 && this.markingSchemaFormEdit.markingSchemaForm.assessorSign4 != "") {
            this.assessorSign4 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.learnerSign4 && this.markingSchemaFormEdit.markingSchemaForm.learnerSign4 != "") {
            this.learnerSign4 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.IQASign4 && this.markingSchemaFormEdit.markingSchemaForm.IQASign4 != "") {
            this.IQASign4 = true
          }

          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.assessorSign5 && this.markingSchemaFormEdit.markingSchemaForm.assessorSign5 != "") {
            this.assessorSign5 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.learnerSign5 && this.markingSchemaFormEdit.markingSchemaForm.learnerSign5 != "") {
            this.learnerSign5 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.IQASign5 && this.markingSchemaFormEdit.markingSchemaForm.IQASign5 != "") {
            this.IQASign5 = true
          }

          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.assessorSign6 && this.markingSchemaFormEdit.markingSchemaForm.assessorSign6 != "") {
            this.assessorSign6 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.learnerSign6 && this.markingSchemaFormEdit.markingSchemaForm.learnerSign6 != "") {
            this.learnerSign6 = true
          }
          if (this.markingSchemaFormEdit.markingSchemaForm && this.markingSchemaFormEdit.markingSchemaForm.IQASign6 && this.markingSchemaFormEdit.markingSchemaForm.IQASign6 != "") {
            this.IQASign6 = true
          }

        }
        // this.selectedTrainer = this.specimanEdit.specimanForm.trainer 
        this.formCreate(this.markingSchemaFormEdit)

      }
    }
    if (changes.singleLearner && changes.singleLearner.currentValue) {
      this.learnerData = changes.singleLearner.currentValue
      console.log("learner data ============>", this.learnerData)
      this.learnerName = this.learnerData.name
      console.log("this learner name======>", this.learnerName)
      console.log("which user ============>", this.learnerData.userType)
      this.formCreate(this.markingSchemaFormEdit)
    }
    // this.formCreate()
  }
  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true

  }
  // UTILITY

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  addSignature(fomrControl) {
    if (this.isLearner && ((fomrControl == 'assessorSign1') || (fomrControl == 'assessorSign2') || (fomrControl == 'assessorSign3') || (fomrControl == 'assessorSign4') || (fomrControl == 'assessorSign5') || (fomrControl == 'assessorSign6') || (fomrControl == 'IQASign1') || (fomrControl == 'IQASign2') || (fomrControl == 'IQASign3') || (fomrControl == 'IQASign4') || (fomrControl == 'IQASign5') || (fomrControl == 'IQASign6'))) {
      // this.handleSnackBar({ msg: "You have no rights to add assessor sign!", button: "Ok" });
      this.markingSchemaForm.get('assessorSign1').disable()
      this.markingSchemaForm.get('assessorSign2').disable()
      this.markingSchemaForm.get('assessorSign3').disable()
      this.markingSchemaForm.get('assessorSign4').disable()
      this.markingSchemaForm.get('assessorSign5').disable()
      this.markingSchemaForm.get('assessorSign6').disable()
      this.markingSchemaForm.get('IQASign1').disable()
      this.markingSchemaForm.get('IQASign2').disable()
      this.markingSchemaForm.get('IQASign3').disable()
      this.markingSchemaForm.get('IQASign4').disable()
      this.markingSchemaForm.get('IQASign5').disable()
      this.markingSchemaForm.get('IQASign6').disable()
    }
    else if (this.isTrainer && ((fomrControl == 'learnerSign1') || (fomrControl == 'learnerSign2') || (fomrControl == 'learnerSign3') || (fomrControl == 'learnerSign4') || (fomrControl == 'learnerSign5') || (fomrControl == 'learnerSign6') || (fomrControl == 'IQASign1') || (fomrControl == 'IQASign2') || (fomrControl == 'IQASign3') || (fomrControl == 'IQASign4') || (fomrControl == 'IQASign5') || (fomrControl == 'IQASign6'))) {
      // this.handleSnackBar({ msg: "You have no rights to add assessor sign!", button: "Ok" });
      this.markingSchemaForm.get('learnerSign1').disable()
      this.markingSchemaForm.get('learnerSign2').disable()
      this.markingSchemaForm.get('learnerSign3').disable()
      this.markingSchemaForm.get('learnerSign4').disable()
      this.markingSchemaForm.get('learnerSign5').disable()
      this.markingSchemaForm.get('learnerSign6').disable()
      this.markingSchemaForm.get('IQASign1').disable()
      this.markingSchemaForm.get('IQASign2').disable()
      this.markingSchemaForm.get('IQASign3').disable()
      this.markingSchemaForm.get('IQASign4').disable()
      this.markingSchemaForm.get('IQASign5').disable()
      this.markingSchemaForm.get('IQASign6').disable()
    }
    else if (this.isIQA && ((fomrControl == 'learnerSign1') || (fomrControl == 'learnerSign2') || (fomrControl == 'learnerSign3') || (fomrControl == 'learnerSign4') || (fomrControl == 'learnerSign5') || (fomrControl == 'learnerSign6') || (fomrControl == 'assessorSign1') || (fomrControl == 'assessorSign2') || (fomrControl == 'assessorSign3') || (fomrControl == 'assessorSign4') || (fomrControl == 'assessorSign5') || (fomrControl == 'assessorSign6'))) {
      this.markingSchemaForm.get('learnerSign1').disable()
      this.markingSchemaForm.get('learnerSign2').disable()
      this.markingSchemaForm.get('learnerSign3').disable()
      this.markingSchemaForm.get('learnerSign4').disable()
      this.markingSchemaForm.get('learnerSign5').disable()
      this.markingSchemaForm.get('learnerSign6').disable()
      this.markingSchemaForm.get('assessorSign1').disable()
      this.markingSchemaForm.get('assessorSign2').disable()
      this.markingSchemaForm.get('assessorSign3').disable()
      this.markingSchemaForm.get('assessorSign4').disable()
      this.markingSchemaForm.get('assessorSign5').disable()
      this.markingSchemaForm.get('assessorSign6').disable()
    } else {
      this.openDialog(CourseSignaturePadComponent).subscribe((data) => {
        console.log("data of sign", data);
        if (data == undefined) return

        let sign = data

        // if (formType == 'trackMaintenance') {
        if (fomrControl == 'assessorSign1') {
          this.assessorSign1 = true
          this.markingSchemaForm.patchValue({
            assessorSign1: sign
          })
        }

        if (fomrControl == 'assessorSign2') {
          this.assessorSign2 = true
          this.markingSchemaForm.patchValue({
            assessorSign2: sign
          })
        }
        if (fomrControl == 'assessorSign3') {
          this.assessorSign3 = true
          this.markingSchemaForm.patchValue({
            assessorSign3: sign
          })
        }
        if (fomrControl == 'assessorSign4') {
          this.assessorSign4 = true
          this.markingSchemaForm.patchValue({
            assessorSign4: sign
          })
        }
        if (fomrControl == 'assessorSign5') {
          this.assessorSign5 = true
          this.markingSchemaForm.patchValue({
            assessorSign5: sign
          })
        }
        if (fomrControl == 'assessorSign6') {
          this.assessorSign6 = true
          this.markingSchemaForm.patchValue({
            assessorSign6: sign
          })
        }
        if (fomrControl == 'learnerSign1') {
          this.learnerSign1 = true
          this.markingSchemaForm.patchValue({
            learnerSign1: sign
          })
        } if (fomrControl == 'learnerSign2') {
          this.learnerSign2 = true
          this.markingSchemaForm.patchValue({
            learnerSign2: sign
          })
        } if (fomrControl == 'learnerSign3') {
          this.learnerSign3 = true
          this.markingSchemaForm.patchValue({
            learnerSign3: sign
          })
        } if (fomrControl == 'learnerSign4') {
          this.learnerSign4 = true
          this.markingSchemaForm.patchValue({
            learnerSign4: sign
          })
        } if (fomrControl == 'learnerSign5') {
          this.learnerSign5 = true
          this.markingSchemaForm.patchValue({
            learnerSign5: sign
          })
        } if (fomrControl == 'learnerSign6') {
          this.learnerSign6 = true
          this.markingSchemaForm.patchValue({
            learnerSign6: sign
          })
        }

        if (fomrControl == 'IQASign1') {
          this.IQASign1 = true
          this.markingSchemaForm.patchValue({
            IQASign1: sign
          })
        } if (fomrControl == 'IQASign2') {
          this.IQASign2 = true
          this.markingSchemaForm.patchValue({
            IQASign2: sign
          })
        } if (fomrControl == 'IQASign3') {
          this.IQASign3 = true
          this.markingSchemaForm.patchValue({
            IQASign3: sign
          })
        } if (fomrControl == 'IQASign4') {
          this.IQASign4 = true
          this.markingSchemaForm.patchValue({
            IQASign4: sign
          })
        } if (fomrControl == 'IQASign5') {
          this.IQASign5 = true
          this.markingSchemaForm.patchValue({
            IQASign5: sign
          })
        } if (fomrControl == 'IQASign6') {
          this.IQASign6 = true
          this.markingSchemaForm.patchValue({
            IQASign6: sign
          })
        }

        // if (fomrControl == 'sign2') {
        //   this.sign2 = true
        //   this.markingSchemaForm.patchValue({
        //     sign2: sign
        //   })
        // }
        // // } else if (formType == 'techCert') {
        // if (fomrControl == 'sign3') {
        //   this.sign3 = true
        //   this.markingSchemaForm.patchValue({
        //     sign3: sign
        //   })
        // }
        // if (fomrControl == 'sign4') {
        //   this.sign4 = true
        //   this.markingSchemaForm.patchValue({
        //     sign4: sign
        //   })
        // }
        // }
      })
    }
  }


  formCreate(details?) {

    console.log("learner name form create ======>", this.learnerName)

    this.markingSchemaForm = new FormGroup({
      learnerName: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerName : this.learnerName),
      learnerNo: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerNo : ''),
      date: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date : ''),
      attemptNo: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.attemptNo : ''),
      failPass1: new FormControl(this.decisionValue(90, 1, 'failPass1')),
      // assessorComment1: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.assessorComment1 : ''),
      assessorComment1: new FormControl(this.remarkGet(90, 1, 'assessorComment1')),
      failPass2: new FormControl(this.decisionValue(90, 2, 'failPass2')),
      assessorComment2: new FormControl(this.remarkGet(90, 2, 'assessorComment2')),
      failPass3: new FormControl(this.decisionValue(90, 3, 'failPass3')),
      assessorComment3: new FormControl(this.remarkGet(90, 3, 'assessorComment3')),
      failPass4: new FormControl(this.decisionValue(90, 4, 'failPass4')),
      assessorComment4: new FormControl(this.remarkGet(90, 4, 'assessorComment4')),
      failPass5: new FormControl(this.decisionValue(90, 5, 'failPass5')),
      assessorComment5: new FormControl(this.remarkGet(90, 5, 'assessorComment5')),
      failPass6: new FormControl(this.decisionValue(90, 6, 'failPass6')),
      assessorComment6: new FormControl(this.remarkGet(90, 6, 'assessorComment6')),
      failPass7: new FormControl(this.decisionValue(90, 7, 'failPass7')),
      assessorComment7: new FormControl(this.remarkGet(90, 7, 'assessorComment7')),
      failPass8: new FormControl(this.decisionValue(90, 8, 'failPass8')),
      assessorComment8: new FormControl(this.remarkGet(90, 8, 'assessorComment8')),
      failPass9: new FormControl(this.decisionValue(90, 9, 'failPass9')),
      assessorComment9: new FormControl(this.remarkGet(90, 9, 'assessorComment9')),
      failPass10: new FormControl(this.decisionValue(90, 10, 'failPass10')),
      assessorComment10: new FormControl(this.remarkGet(90, 10, 'assessorComment10')),
      failPass11: new FormControl(this.decisionValue(90, 11, 'failPass11')),
      assessorComment11: new FormControl(this.remarkGet(90, 11, 'assessorComment11')),
      feedback1: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.feedback1 : ''),
      date2: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date2 : ''),
      date3: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date3 : ''),
      date4: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date4 : ''),
      date5: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date5 : ''),
      //  form second
      learnerName1: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerName1 : this.learnerName),
      learnerNo1: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerNo1 : ''),
      attemptNo1: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.attemptNo1 : ''),
      date6: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date6 : ''),
      // attemptNo12: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.attemptNo12 : ''),
      failPass12: new FormControl(this.decisionValue(91, 1, 'failPass12')),
      assessorComment12: new FormControl(this.remarkGet(91, 1, 'assessorComment12')),
      failPass13: new FormControl(this.decisionValue(91, 2, 'failPass13')),
      assessorComment13: new FormControl(this.remarkGet(91, 2, 'assessorComment13')),
      failPass14: new FormControl(this.decisionValue(91, 3, 'failPass14')),
      assessorComment14: new FormControl(this.remarkGet(91, 3, 'assessorComment14')),
      failPass15: new FormControl(this.decisionValue(91, 4, 'failPass15')),
      assessorComment15: new FormControl(this.remarkGet(91, 4, 'assessorComment15')),
      failPass16: new FormControl(this.decisionValue(91, 5, 'failPass16')),
      assessorComment16: new FormControl(this.remarkGet(91, 5, 'assessorComment16')),
      failPass17: new FormControl(this.decisionValue(91, 6, 'failPass17')),
      assessorComment17: new FormControl(this.remarkGet(91, 6, 'assessorComment17')),
      failPass18: new FormControl(this.decisionValue(91, 7, 'failPass18')),
      assessorComment18: new FormControl(this.remarkGet(91, 7, 'assessorComment18')),
      failPass19: new FormControl(this.decisionValue(91, 8, 'failPass19')),
      assessorComment19: new FormControl(this.remarkGet(91, 8, 'assessorComment19')),
      failPass20: new FormControl(this.decisionValue(91, 9, 'failPass20')),
      assessorComment20: new FormControl(this.remarkGet(91, 9, 'assessorComment20')),
      failPass21: new FormControl(this.decisionValue(91, 10, 'failPass21')),
      assessorComment21: new FormControl(this.remarkGet(91, 10, 'assessorComment21')),
      failPass22: new FormControl(this.decisionValue(91, 11, 'failPass22')),
      assessorComment22: new FormControl(this.remarkGet(91, 11, 'assessorComment22')),
      feedback2: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.feedback2 : ''),
      date7: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date7 : ''),
      date8: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date8 : ''),
      date9: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date9 : ''),
      date10: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date10 : ''),
      //  form third form
      learnerName2: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerName2 : this.learnerName),
      learnerNo2: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerNo2 : ''),
      date11: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date11 : ''),
      attemptNo2: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.attemptNo2 : ''),
      failPass23: new FormControl(this.decisionValue(92, 1, 'failPass23')),
      assessorComment23: new FormControl(this.remarkGet(92, 1, 'assessorComment23')),
      failPass24: new FormControl(this.decisionValue(92, 2, 'failPass24')),
      assessorComment24: new FormControl(this.remarkGet(92, 2, 'assessorComment24')),
      failPass25: new FormControl(this.decisionValue(92, 3, 'failPass25')),
      assessorComment25: new FormControl(this.remarkGet(92, 3, 'assessorComment25')),
      failPass26: new FormControl(this.decisionValue(92, 4, 'failPass26')),
      assessorComment26: new FormControl(this.remarkGet(92, 4, 'assessorComment26')),
      failPass27: new FormControl(this.decisionValue(92, 5, 'failPass27')),
      assessorComment27: new FormControl(this.remarkGet(92, 5, 'assessorComment27')),
      failPass28: new FormControl(this.decisionValue(92, 6, 'failPass28')),
      assessorComment28: new FormControl(this.remarkGet(92, 6, 'assessorComment28')),
      failPass29: new FormControl(this.decisionValue(92, 7, 'failPass29')),
      assessorComment29: new FormControl(this.remarkGet(92, 7, 'assessorComment29')),
      failPass30: new FormControl(this.decisionValue(92, 8, 'failPass30')),
      assessorComment30: new FormControl(this.remarkGet(92, 8, 'assessorComment30')),
      failPass31: new FormControl(this.decisionValue(92, 9, 'failPass31')),
      assessorComment31: new FormControl(this.remarkGet(92, 9, 'assessorComment31')),
      feedback3: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.feedback3 : ''),
      date12: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date12 : ''),
      date13: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date13 : ''),
      date14: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date14 : ''),
      date15: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date15 : ''),
      //  form forth form
      learnerName3: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerName3 : this.learnerName),
      learnerNo3: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerNo3 : ''),
      date16: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date16 : ''),
      attemptNo3: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.attemptNo3 : ''),
      failPass32: new FormControl(this.decisionValue(93, 1, 'failPass32')),
      assessorComment32: new FormControl(this.remarkGet(93, 1, 'assessorComment32')),
      failPass33: new FormControl(this.decisionValue(93, 2, 'failPass33')),
      assessorComment33: new FormControl(this.remarkGet(93, 2, 'assessorComment33')),
      failPass34: new FormControl(this.decisionValue(93, 3, 'failPass34')),
      assessorComment34: new FormControl(this.remarkGet(93, 3, 'assessorComment34')),
      failPass35: new FormControl(this.decisionValue(93, 4, 'failPass35')),
      assessorComment35: new FormControl(this.remarkGet(93, 4, 'assessorComment35')),
      failPass36: new FormControl(this.decisionValue(93, 5, 'failPass36')),
      assessorComment36: new FormControl(this.remarkGet(93, 5, 'assessorComment36')),
      failPass37: new FormControl(this.decisionValue(93, 6, 'failPass37')),
      assessorComment37: new FormControl(this.remarkGet(93, 6, 'assessorComment37')),
      failPass38: new FormControl(this.decisionValue(93, 7, 'failPass38')),
      assessorComment38: new FormControl(this.remarkGet(93, 7, 'assessorComment38')),
      failPass39: new FormControl(this.decisionValue(93, 8, 'failPass39')),
      assessorComment39: new FormControl(this.remarkGet(93, 8, 'assessorComment39')),
      failPass40: new FormControl(this.decisionValue(93, 9, 'failPass40')),
      assessorComment40: new FormControl(this.remarkGet(93, 9, 'assessorComment40')),
      failPass41: new FormControl(this.decisionValue(93, 10, 'failPass41')),
      assessorComment41: new FormControl(this.remarkGet(93, 10, 'assessorComment41')),
      failPass42: new FormControl(this.decisionValue(93, 11, 'failPass42')),
      assessorComment42: new FormControl(this.remarkGet(93, 11, 'assessorComment42')),
      feedback4: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.feedback4 : ''),
      date17: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date17 : ''),
      date18: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date18 : ''),
      date19: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date19 : ''),
      date20: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date20 : ''),
      //  form fifth form
      learnerName4: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerName4 : this.learnerName),
      learnerNo4: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerNo4 : ''),
      date21: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date21 : ''),
      attemptNo4: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.attemptNo4 : ''),
      failPass43: new FormControl(this.decisionValue(96, 1, 'failPass43')),
      assessorComment43: new FormControl(this.remarkGet(96, 1, 'assessorComment43')),
      failPass44: new FormControl(this.decisionValue(96, 2, 'failPass44')),
      assessorComment44: new FormControl(this.remarkGet(96, 2, 'assessorComment44')),
      failPass45: new FormControl(this.decisionValue(96, 3, 'failPass45')),
      assessorComment45: new FormControl(this.remarkGet(96, 3, 'assessorComment45')),
      feedback5: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.feedback5 : ''),
      date22: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date22 : ''),
      date23: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date23 : ''),
      date24: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date24 : ''),
      date25: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date25 : ''),


      learnerName5: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerName5 : this.learnerName),
      learnerNo5: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerNo5 : ''),
      date26: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date26 : ''),
      attemptNo5: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.attemptNo5 : ''),
      failPass46: new FormControl(this.decisionValue(99, 1, 'failPass46')),
      assessorComment46: new FormControl(this.remarkGet(99, 1, 'assessorComment46')),
      failPass47: new FormControl(this.decisionValue(99, 2, 'failPass47')),
      assessorComment47: new FormControl(this.remarkGet(99, 2, 'assessorComment47')),
      failPass48: new FormControl(this.decisionValue(99, 3, 'failPass48')),
      assessorComment48: new FormControl(this.remarkGet(99, 3, 'assessorComment48')),
      failPass49: new FormControl(this.decisionValue(99, 4, 'failPass49')),
      assessorComment49: new FormControl(this.remarkGet(99, 4, 'assessorComment49')),
      failPass50: new FormControl(this.decisionValue(99, 5, 'failPass50')),
      assessorComment50: new FormControl(this.remarkGet(99, 5, 'assessorComment50')),
      failPass51: new FormControl(this.decisionValue(99, 6, 'failPass51')),
      assessorComment51: new FormControl(this.remarkGet(99, 6, 'assessorComment51')),
      failPass52: new FormControl(this.decisionValue(99, 7, 'failPass52')),
      assessorComment52: new FormControl(this.remarkGet(99, 7, 'assessorComment52')),
      feedback6: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.feedback6 : ''),
      date27: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date27 : ''),
      date28: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date28 : ''),
      date29: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date29 : ''),
      date30: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.date30 : ''),

      assessorSign1: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.assessorSign1 : ''),
      learnerSign1: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerSign1 : ''),
      IQASign1: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.IQASign1 : ''),
      assessorSign2: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.assessorSign2 : ''),
      learnerSign2: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerSign2 : ''),
      IQASign2: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.IQASign2 : ''),
      assessorSign3: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.assessorSign3 : ''),
      learnerSign3: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerSign3 : ''),
      IQASign3: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.IQASign3 : ''),
      assessorSign4: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.assessorSign4 : ''),
      learnerSign4: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerSign4 : ''),
      IQASign4: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.IQASign4 : ''),
      assessorSign5: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.assessorSign5 : ''),
      learnerSign5: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerSign5 : ''),
      IQASign5: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.IQASign5 : ''),
      assessorSign6: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.assessorSign6 : ''),
      learnerSign6: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.learnerSign6 : ''),
      IQASign6: new FormControl((details && details.markingSchemaForm) ? details.markingSchemaForm.IQASign6 : '')

    })

  }



  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'markingSchemaForm')
      this.markingSchemaForm.get(formControl).setValue(value);
  }



  markingSchemaSubmit() {
    console.log("markingSchemaSubmit ===========>", this.markingSchemaForm.value)


    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobData._id,
      version: true,
      details: {
        markingSchemaForm: this.markingSchemaForm.value,
      },
      type: 'markingScheme'
    }
    this.loading = true
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("Marking Schema not accepted", err)
    })

  }




  remarkGet(unitNo, assignment, formcontrol?) {
    // console.log("here is data", unitNo, assignment, formcontrol)
    // console.log("THis is the remark list", this);


    for (var i = 0; i < this.remarkList.length; i++) {

      if (this.remarkList[i].assignment.unitNo == unitNo && this.remarkList[i].assignment.assignmentNo == assignment) {
        // this.markingSchemaForm.control
        //  return this.markingSchemaForm.get(formcontrol).setValue((this.remarkList[i].remark[0] && this.remarkList[i].remark[0].text) ? this.remarkList[i].remark[0].text : this.markingSchemaForm.get(formcontrol).value);

        // if (formcontrol != undefined && this.markingSchemaForm.get(formcontrol).value) {
        //   // console.log("call if For First time", this.markingSchemaForm.get(formcontrol).value , formcontrol)

        //   let formvalue = this.markingSchemaForm.get(formcontrol).value
        //   return formvalue
        // }
        if (this.remarkList[i].remark[0] && this.remarkList[i].remark[0].text) {
          // console.log("call else if", this.remarkList[i].remark[0].text)
          this.markingSchemaForm.get(formcontrol).setValue(this.remarkList[i].remark[0].text);
          return this.remarkList[i].remark[0].text
        }
        else {
          // console.log("else");

          return ''
        }
      }

    }
  }


  decisionValue(unitNo, assignment, formcontrol?) {

    for (var i = 0; i < this.remarkList.length; i++) {
      // console.log("what is the unit number", this.remarkList[i].assignment);

      if (this.remarkList[i].assignment.unitNo == unitNo && this.remarkList[i].assignment.assignmentNo == assignment) {

        if (formcontrol != undefined && this.markingSchemaForm.get(formcontrol).value) {
          // console.log("call if", this.markingSchemaForm.get(formcontrol).value , formcontrol)

          let formvalue = this.markingSchemaForm.get(formcontrol).value
          return formvalue
        } else {
          // if (this.remarkList[i].remark[0] && this.remarkList[i].remark[0].text) {
          // this.markingSchemaForm.get(formcontrol).setValue(this.remarkList[i].remark[0].text);
          // return this.remarkList[i].remark[0].text
          if (this.remarkList[i].status == 'Completed') {
            // console.log("call else if", this.remarkList[i].remark[0].text)
            this.markingSchemaForm.get(formcontrol).setValue('Pass');
            return 'Pass'
          }
        }


      }

    }


  }


  // getRemarknew(unitNo, assignment, formcontrol) {
  //   for (var i = 0; i < this.remarkList.length; i++) {
  //     console.log("form control hereee", formcontrol)
  //     if (this.remarkList[i].assignment.unitNo == unitNo && this.remarkList[i].assignment.assignmentNo == assignment) {
  //       // console.log("here unit no", this.remarkList[i].assignment.unitNo)
  //       if (this.markingSchemaForm.get(formcontrol).value) {
  //          // return this.markingSchemaForm.get(formcontrol).value
  //           let formvalue=this.markingSchemaForm.get(formcontrol).value
  //           return formvalue
  //       }
  //       else if (this.remarkList[i].remark[0] && this.remarkList[i].remark[0].text) {
  //         //  return   this.markingSchemaForm.controls[formcontrol].setValue(this.remarkList[i].remark[0].text);
  //         return this.remarkList[i].remark[0].text
  //       }
  //       else {
  //         // return ''
  //       }
  //     }

  //   }
  // }




  getRemark(jobId) {
    console.log("here is jobdata !!!!####====>", this.jobData)
    console.log("what is leaner data ", this.learnerData);

    let learnerId
    if (this.learnerData && this.learnerData._id) {
      learnerId = this.learnerData._id
    }
    let data = {
      learnerId: this.selectedLearner,
      jobId: jobId
    }

    console.log("data to be send", data);

    this._learnerService.getRemark(data).subscribe((data) => {
      console.log("here is the response of remark data !!!", data)
      if (data && data.data) {
        this.remarkList = data.data;
        this.formCreate(this.markingSchemaFormEdit)
        // if (this.isConnect) {
        // setTimeout(() => {
        this.ngAfterViewInit()
        // }, 100)
        // }
      }
    }, (error) => {
      console.log("here is the error log!!!!", error);

    })
  }

  markingSubmit(data) {
    return new Promise((resolve, reject) => {
      console.log("When click on download", data);
      this.parrentJobId = data.jobId
      this.selectedLearner = data.learnerId
      this.formCreate()
      this._learnerService.getPolicyData(data.learnerId, data.jobId).subscribe(res => {
        console.log("policy in learner dashboard", res)
        this.learnerData = res.learnerId
        this.learnerName = res.learnerId.name
        this.markingSchemaFormEdit = res.details
        this.getRemark(data.jobId)
        this.isConnect = true
        // this.formCreate(res.details)
        // setTimeout(() => {
        //   this.ngAfterViewInit()
        // }, 100)

        // console.log("learner========>", this.learner)
        // console.log("job =================>", this.job)
        // if (res && res != null) {
        //   this.assessmentPlanEdit = res.details
        // } else this.assessmentPlanEdit = null
      })
    })
  }



  ngAfterViewInit() {
    console.log("After initaliz the form", JSON.parse(JSON.stringify(this.markingSchemaForm.value)));

    if (this.isConnect) {
      let data = {
        learnerId: this.learnerData._id,
        jobId: this.parrentJobId,
        version: true,
        details: {
          markingSchemaForm: this.markingSchemaForm.value,
        },
        type: 'markingScheme'
      }
      // this.loading = true
      console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
      this._learnerService.submitPolicy(data).subscribe(res => {
        console.log('Policy res', res);
        // this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
        // this.loading = false
      }, (err) => {
        // this.loading = false
        console.log("Marking Schema not accepted", err)
      })
    }

  }
}
